import { PhoneNumberType } from '@vista-digital/ocapi-types/v1';
export const mapMemberPhoneNumbers = (phoneNumbers) => {
    const mobile = phoneNumbers.find(ph => ph.type === PhoneNumberType.Mobile) || { number: '' };
    const home = phoneNumbers.find(ph => ph.type === PhoneNumberType.Home) || { number: '' };
    return {
        mobileNumber: mobile.number,
        homeNumber: home.number
    };
};
//# sourceMappingURL=map-member-phone-numbers.js.map